<!--客户跟进组件-->
<template>
    <el-dialog title="填写跟进记录" :visible.sync="isShow" :before-close="handleClose">

        <el-form :model="form" ref="form" :rules="rules">

            <!-- <el-form-item v-if="customer" label="跟进客户" :label-width="formLabelWidth">
                {{customer.name || '==' }}
            </el-form-item> -->

            <el-form-item label="跟进产品" prop="product_id" :label-width="formLabelWidth">
                <el-select v-model="form.product_id" placeholder="请选择跟进产品">
                    <el-option v-for="product in products" :key="product.id" :label="product.name" :value="product.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="联系人" prop="contact_id" :label-width="formLabelWidth">
                <el-select v-model="form.contact_id" placeholder="请选择联系人" size="small">
                    <el-option v-for="contact in contacts" :key="contact.id" :label="contact.name" :value="contact.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="跟进内容" prop="content" :label-width="formLabelWidth">
                <el-input type="textarea" :rows="5" v-model="form.content" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="下次跟进时间" prop="next_time" :label-width="formLabelWidth">
                <el-date-picker
                        v-model="form.next_time"
                        type="datetime"
                        placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button :loading="loading" type="primary" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { CustomerTrace, normalizeNextTime } from "~/services/CustomerTrace";
import CustomerTraceService from "~/services/CustomerTrace";
import ProductService from "~/services/product";
import CustomerService from "~/services/customer";

export default {
    name: "TraceModal",
    components: {},
    props: {
        
        // 是否显示当前对话框
        showDialog: {
            type: Boolean,
            required: true
        },

        // 外部传入的客户ID
        customerId: {
            type: Number,
            default: 0,
            required: true
        },
        // 是否开启回调，开启后表单填入的数据会回传给上层组件
        // 由上层处理数据的提交入库
        enableCallback: {
            type: Boolean,
            default: false, 
        },

        // 当数据需要由上层处理时由上层来告诉当前组件是否完成了操作
        isFinished: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            products: [],
            contacts: [],
            customer: {},
            form: CustomerTrace,
            formLabelWidth: "120px",
            isShow: false,
            loading: false,
            rules: {
                content: [
                    {
                        required: true,
                        message: "请输入跟进内容"
                    }
                ],
                product_id: [
                    {
                        required: true,
                        message: "必须选择一个产品"
                    }
                ],
                contact_id: [
                    {
                        required: true,
                        message: "联系人不能为空"
                    }
                ]
            }
        };
    },
    created: function() {
        if (this.products.length == 0) {
            this.getProducts();
        }

        // 此处在将当前组件嵌套至第三层时 customerId 有根据外部传入改变
        // 但是 watch 没能监听到 所以这里临时打个补丁
        if (!this.customer.name && this.customerId > 0) {
            let CustomerId = this.customerId;
            this.getCustomer(CustomerId);
            this.getContacts(CustomerId);
            this.form.customer_id = CustomerId;
        }

    },
    watch: {
        // 监听属性 showDialog
        showDialog: function(value, original) {
            this.isShow = value;
        },

        // 监听属性 customerId
        customerId: function (value, original) {
            if (parseInt(value) > 0) {
                this.getCustomer(value);
                this.getContacts(value);
                this.form.customer_id = value;
            }
        },

        isFinished: function(value, original) {
            if (value == true) {
                this.loading = false;
                this.close();
            }
        }
    },
    methods: {

        // 通过 CustomerId 获取客户信息
        getCustomer(customerId) {
            CustomerService.getInfo(customerId).then(res => {
                if (res && res.data) {
                    this.customer =  res.data;
                }
            }).catch(error => {
                console.error(error);
            })
        },

        // 得到产品列表
        getProducts() {
            ProductService.getOptionList()
                .then(res => {
                    if (res && res.data) {
                        this.products = res.data;
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },
        // 得到客户的联系人列表
        getContacts(customerId) {
            CustomerService.getContacts(customerId).then(res => {
                if (res && res.data) {
                    this.contacts = res.data;
                }
            }).catch(error => {
                console.error(error);
            });
        },

        // 关闭窗口
        handleClose() {
            this.close();
        },

        // 处理用户选择
        handleUserSelect(UserId) {
            this.form.executor_id = UserId;
        },

        // 关闭当前窗口
        close() {
            this.isShow = false;
            // 往上层组件传递更改后的状态
            this.$emit("closeModal", this.isShow);
            this.$refs["form"].resetFields();
        },

        // 提交表单
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.enableCallback == true) {
                        // 直接将数据通过事件回传给上层数据处理
                        this.$emit("traceCallBack", normalizeNextTime(this.form));
                        return;
                    } else {
                        // 直接提交跟进记录入库
                        CustomerTraceService.create(this.form).then(res => {
                            this.loading = false;
                            if (res && res.code == 0) {
                                this.$message({type: "success", message: "执行成功!"});
                                this.close();
                                this.$emit("saveCallback", res.data)
                            }
                        }).catch(err => {
                            this.loading = false;
                            console.error(err);
                        })
                    }
                } else {
                    return;
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/tasks/TraceModal.vue